import React from 'react';
import palette from '../../color-palette';

interface DessertsProps {
  darkMode: boolean;
}

const Desserts = ({ darkMode, ...props }: DessertsProps) => {
  const {
    primary: { main },
    common: { white },
  } = palette;

  return (
    <svg
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.18 12.38a.18.18 0 0 0-.14-.07h-1.56c.1-.3.14-.62.15-.93a3.64 3.64 0 0 0-3.12-3.62 3.67 3.67 0 1 0-7.18-.96 3.66 3.66 0 0 0-3.26 3.64c0 .66.19 1.3.54 1.87H5.95a.18.18 0 0 0-.14.08.17.17 0 0 0 0 .15c.18.52.45 1 .81 1.4 1.06 1.18 3.27 3.21 6.3 3.62a.7.7 0 0 1 .22.15v2.87c0 1.55-.03 3.22-.03 3.52-.1.1-.23.17-.37.2h-.41c-1.3.04-2.23.1-2.23.6a.36.36 0 0 0 .12.25c.3.3 1.25.36 2.52.36h1.86c1.63 0 2.9 0 3.27-.35a.35.35 0 0 0 .11-.26c0-.5-.93-.56-2.23-.6h-.37a.8.8 0 0 1-.4-.2l-.06-3.52c0-1.46-.04-2.8-.04-2.85a.54.54 0 0 1 .22-.17c.18-.02.37-.05.55-.09 5.59-1.14 6.53-4.8 6.56-4.94a.17.17 0 0 0-.03-.15Zm-1.9-1.02c0 .32-.05.63-.15.93h-6.26c.04-.05.06-.11.1-.18l.1-.2.11-.28.07-.2.08-.33.03-.17c.03-.17.04-.35.04-.52v-.1l.2-.03.23-.04c.1 0 .2-.05.29-.08l.2-.07c.1-.03.2-.08.29-.13l.17-.08.3-.19.13-.09c.13-.1.26-.2.38-.32.04-.04.07-.1.11-.13l.22-.26c.07-.08.08-.12.12-.18l.16-.24.1-.21.1-.2a3.29 3.29 0 0 1 2.88 3.3ZM14 3.38a3.32 3.32 0 0 1 2.92 4.88c0 .05-.06.1-.09.14-.03.05-.1.18-.17.26l-.12.15a3.07 3.07 0 0 1-.52.51l-.18.12-.21.14-.2.1-.23.1-.2.07a2.3 2.3 0 0 1-.24.07l-.22.04h-.17c0-.04 0-.09-.02-.14v-.11a3.65 3.65 0 0 0-3.61-2.95h-.05V6.7A3.32 3.32 0 0 1 14 3.38Zm-6.58 7.05a3.31 3.31 0 0 1 2.95-3.27l.18-.02h.16a3.3 3.3 0 0 1 3.33 3.08v.23c0 .67-.2 1.32-.58 1.87v.02H8c-.4-.56-.6-1.23-.6-1.91Zm7.85 14.22h.41c.47 0 1.78.05 1.87.24-.13.3-2.23.27-3.03.26h-1.09c-.8 0-2.89.04-3.01-.24.1-.2 1.4-.25 1.89-.26h.43c.35-.07.68-.3.68-.5 0-.06 0-1.86.03-3.57 0-1.46.03-2.83.03-2.87a.3.3 0 0 0-.03-.09h1.04a.3.3 0 0 0-.02.11l.04 2.87.05 3.57c0 .17.34.4.71.48Zm.25-7.52-.57.09c-.65.08-1.3.08-1.96 0-2.94-.38-5.1-2.37-6.13-3.5-.27-.32-.5-.68-.65-1.06H21.8c-.3.8-1.64 3.52-6.28 4.47Z"
        fill={darkMode ? white : main}
      />
    </svg>
  );
};

export default Desserts;
